// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
// Small shared building blocks for views (headings, tiles, legends).

export function sectionHead(title: string, sub: string): string {
  return `<div class="sec-head"><h2>${title}</h2><p class="sec-sub">${sub}</p></div>`;
}

export function statTile(value: string, label: string, sub = ''): string {
  return `<div class="stat"><div class="stat-v">${value}</div><div class="stat-l">${label}</div>${sub ? `<div class="stat-s">${sub}</div>` : ''}</div>`;
}

export function legendHtml(loLabel: string, hiLabel: string, stops: Array<{ label: string; color: string }>): string {
  return `<div class="ramp-legend">
    <span class="ramp-end">${loLabel}</span>
    <span class="ramp-bar">${stops.map((s) => `<span class="ramp-cell" style="background:${s.color}" title="${s.label} °C"></span>`).join('')}</span>
    <span class="ramp-end">${hiLabel}</span>
  </div>`;
}
